import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicLayout from '../components/PublicLayout';
import { Calendar, MapPin, Users, Clock } from 'lucide-react';

const EventsPage = () => {
  const navigate = useNavigate();

  const upcomingEvents = [
    {
      title: "Annual Entrepreneurship Summit",
      date: "March 15, 2025",
      time: "9:00 AM - 5:00 PM",
      location: "Downtown Convention Center",
      attendees: "200+ Expected",
      description: "Network with top entrepreneurs and learn strategies for scaling your business."
    },
    {
      title: "Investment Networking Mixer",
      date: "March 22, 2025",
      time: "6:00 PM - 9:00 PM",
      location: "The Rooftop Lounge",
      attendees: "75+ Expected",
      description: "Connect with angel investors and VCs looking for their next opportunity."
    },
    {
      title: "Digital Marketing Masterclass",
      date: "April 5, 2025",
      time: "2:00 PM - 4:00 PM",
      location: "Virtual Event",
      attendees: "150+ Expected",
      description: "Master the latest digital marketing strategies from industry experts."
    }
  ];

  return (
    <PublicLayout>
      <div className="public-page">
        {/* Hero Section */}
        <div className="public-page-header">
          <h1>Exclusive Events</h1>
          <p>
            Join networking events, workshops, and conferences designed to accelerate your success.
          </p>
        </div>

        <div className="public-page-content">
          {/* Events Grid */}
          <div className="space-y-8 mb-16">
            {upcomingEvents.map((event, index) => (
              <div key={index} className="event-card">
                <div className="event-card-content">
                  <h3 style={{fontFamily: 'var(--font-heading)', fontSize: '2rem', marginBottom: '1rem'}}>{event.title}</h3>
                  
                  <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                    <div className="flex items-center gap-2">
                      <Calendar className="w-5 h-5" style={{color: 'var(--gold)'}} />
                      <span style={{color: 'var(--muted)'}}>{event.date}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Clock className="w-5 h-5" style={{color: 'var(--gold)'}} />
                      <span style={{color: 'var(--muted)'}}>{event.time}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <MapPin className="w-5 h-5" style={{color: 'var(--gold)'}} />
                      <span style={{color: 'var(--muted)'}}>{event.location}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Users className="w-5 h-5" style={{color: 'var(--gold)'}} />
                      <span style={{color: 'var(--muted)'}}>{event.attendees}</span>
                    </div>
                  </div>
                  
                  <p style={{color: 'var(--muted)', marginBottom: '1.5rem'}}>{event.description}</p>
                  
                  <button 
                    onClick={() => navigate('/auth')}
                    className="btn-primary"
                  >
                    Register Now
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="text-center rounded-2xl p-12" style={{background: 'var(--dark-bg)', color: '#fff'}}>
            <h2 className="mb-4" style={{color: '#fff', fontFamily: 'var(--font-heading)', fontSize: '3rem'}}>Want to Host Your Own Event?</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto" style={{color: 'rgba(255,255,255,0.8)'}}>
              Become a host and create exclusive events for our community.
            </p>
            <button 
              onClick={() => navigate('/auth')}
              className="btn-primary"
            >
              Become a Host
            </button>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default EventsPage;